<hb-modal-dialog (okClicked)="okClick()">
  <div content>
    <hb-table
      [id]="config?.id"
      [data]="failureModes"
      [config]="config"
      (selectionChange)="onSelectionChange($event)"
      [selectedItems]="selectedFailureModes"
    ></hb-table>
  </div>
</hb-modal-dialog>
